/*
 * Shipping protection price (merch only: donations never get protection), shared by
 * assets/ccm-store.js (window.CCMProtection) and tests/protection.test.mjs. The price is 3% of the
 * merch subtotal or $1.99, whichever is greater, rounded to the cent, and never more than $3.99.
 * The Shipping Protection product has one variant per cent from $1.99 (the product holds more, up to
 * $22.46; only $1.99 to $3.99 are used).
 * Variants are found through templates/product.ccm-map.liquid, 250 per page.
 */
(function (root, make) {
  if (typeof module === "object" && module.exports) module.exports = make();
  else root.CCMProtection = make();
})(this, function () {
  "use strict";

  var MIN = 199;
  var MAX = 399; // the owner's cap: $3.99 (3% reaches it at a $133 merch subtotal)
  var PER_PAGE = 250;

  /** Protection price in cents for a merch subtotal in cents (0 for an empty cart). */
  function cents(subtotal) {
    if (!(subtotal > 0)) return 0;
    return Math.min(MAX, Math.max(MIN, Math.round((subtotal * 3) / 100)));
  }

  /** The Shipping Protection line itself (cart item from /cart.js). */
  function isProtection(item) {
    return item.product_type === "Shipping Protection" || item.handle === "shipping-protection";
  }

  /** Merch subtotal in cents: every cart line except donations and the protection line. */
  function subtotal(items) {
    return (items || []).reduce(function (s, i) {
      if (isProtection(i) || String(i.product_type || "").indexOf("Donation") === 0) return s;
      return s + i.final_line_price;
    }, 0);
  }

  /** Where the variant for a price sits in the ccm-map view: page (from 1) and offset on it. */
  function locate(price) {
    var i = price - MIN;
    return { page: Math.floor(i / PER_PAGE) + 1, offset: i % PER_PAGE };
  }

  return { MIN: MIN, MAX: MAX, HANDLE: "shipping-protection", TYPE: "Shipping Protection", cents: cents, subtotal: subtotal, isProtection: isProtection, locate: locate };
});
